import { Link, useLoaderData } from 'react-router-dom';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import type { ProfilesLoaderType } from './queries';
import type { IProfile } from './types';

import { useProfilesQuery } from './queries';
import { usePagination } from '@/hooks/usePagination';
import { useColumns } from './useColumns';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';

export const Profiles = () => {
  const { t } = useTranslation();
  const initialData = useLoaderData() as ProfilesLoaderType;
  const { data: profiles, isLoading } = useProfilesQuery(initialData);

  return (
    <>
      <PageHeader
        title={t('profiles.title')}
        description={t('profiles.description')}
        extra={
          <Link to={routes.profileCreate()}>
            <Button type='primary'>{t('profiles.createButtonText')}</Button>
          </Link>
        }
      />
      <Table<IProfile>
        rowKey='id'
        dataSource={profiles.data ?? []}
        loading={isLoading}
        columns={useColumns()}
        pagination={usePagination(profiles.total, profiles.per_page)}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};
